// extracted by mini-css-extract-plugin
export default {"startSell":"StartSell_startSell__b0kz4","titleSell":"StartSell_titleSell__EgNYk","body2":"StartSell_body2__wrS+u","loginLink":"StartSell_loginLink__7MXTn"};